import React, { useState, useEffect, useCallback } from "react";
import AICallsTable from "../AICallsTable";
import ApiEndPoints from "../../../../ServicesCalls/ApiEndPoints";
// import SampleDataTable from "../../../../Assets/mockData/tableSampleData.json";
import PageTableHeaderCols from "../../../reusable-components/PageTableHeaderCols";
import { getApiTokenFromLocalstorage } from "../../../reusable-components/PageFormats";

const POLLING_INTERVAL_MS = 2000;
export default function OpenCalls() {
  const TableHeaderCols = PageTableHeaderCols({ PageName: "OpenCalls" });

  const [openCallsTableErr, setOpenCallsTableErr] = useState(null);
  const [openCallsTableData, setOpenCallsTableData] = useState(null);
  const [isOpenCallsLoading, setIsOpenCallsLoading] = useState(true);

  const fetchOpenCallsData = useCallback(async () => {
    try {
      setOpenCallsTableErr(null);
      const requestHeaders = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getApiTokenFromLocalstorage()}`,
        },
      };
      const response = await fetch(
        ApiEndPoints.getAdminOpenCalls(),
        requestHeaders
      );
      const data = await response.json();
      const dataMsg = data?.message;

      if (!response.ok)
        throw new Error(dataMsg || "Failed to Fetch ActiveAgent API");

      const dataCalls = data?.ActiveAgents;
      const arrDataRes =
        data && dataCalls
          ? Array.isArray(dataCalls)
            ? dataCalls
            : [dataCalls]
          : null;
      setOpenCallsTableData(arrDataRes);
    } catch (err) {
      const errorMsg = err.message;
      console.error(errorMsg);
      setOpenCallsTableData(null);
      setOpenCallsTableErr(errorMsg);
      return;
    } finally {
      setIsOpenCallsLoading(false);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(fetchOpenCallsData, POLLING_INTERVAL_MS);
    fetchOpenCallsData(); // Initial call
    return () => clearInterval(interval);
  }, [fetchOpenCallsData]);

  return (
    <>
      <div>
        {isOpenCallsLoading ? (
          <div className="flex items-center justify-center h-48">
            <div className="w-8 h-8 pr-2 mr-3 border-t-2 border-blue-800 rounded-full animate-spin"></div>
            <span className="py-8 text-center text-blue-500">
              Loading Open Calls Data...
            </span>
          </div>
        ) : openCallsTableErr ? (
          <div className="py-8 text-center text-red-600">
            {openCallsTableErr}
          </div>
        ) : (
          openCallsTableData && (
            <div className="mt-6">
              <AICallsTable
                PageName="OpenCalls"
                TableColumns={TableHeaderCols}
                TableData={openCallsTableData}
              />
            </div>
          )
        )}
      </div>
    </>
  );
}
